import NoAccessView from '@/views/NoAccessView.vue';

const no_access_routes = {
  path: 'no-access',
  name: 'no-access',
  component: NoAccessView,
};

export default no_access_routes;
